import { useNavigationViewport } from "components/scrapEyeDataDashboard/navigation/useNavigationViewport";
import { Stack } from "@mui/material";

import DateTimeControls from "../components/DateTimeControls";
import { HeatCoverageTimelinePlot } from "./plots/HeatCoverageTimelinePlot";
import { MaterialUsagePlot } from "./plots/MaterialUsagePlot";
import { CumulativeMaterialUsagePlot } from "./plots/CumulativeMaterialUsagePlot";
import { StrikesOverTimePlot } from "./plots/StrikesOverTimePlot";
import { useHeatsData } from "./hooks/useHeatsData";

export const ScrapEyeDataDashboardAnalysis = () => {
  const { start, end, pickerValue, handleRangeChange } = useNavigationViewport(
    "analysisRange",
    30
  );

  // Use chunked heats data
  const { data: heatsData, chunks: heatsChunks } = useHeatsData(start, end);

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {/* Time controls using shared DateTimeControls */}
      <DateTimeControls
        pickerValue={pickerValue}
        onRangeChange={handleRangeChange}
      />

      {/* Heat coverage timeline */}
      <HeatCoverageTimelinePlot
        heatsData={heatsData}
        start={start}
        end={end}
        chunks={heatsChunks}
      />

      {/* Material usage over time */}
      <MaterialUsagePlot
        heatsData={heatsData}
        start={start}
        end={end}
        chunks={heatsChunks}
      />

      {/* Cumulative material usage */}
      <CumulativeMaterialUsagePlot
        heatsData={heatsData}
        start={start}
        end={end}
        chunks={heatsChunks}
      />

      {/* Strikes over time - all scenarios */}
      <StrikesOverTimePlot
        heatsData={heatsData}
        start={start}
        end={end}
        chunks={heatsChunks}
      />
    </Stack>
  );
};
